import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';

import { AuthGuard } from './shared/guards/auth.guard';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { TeacherLayoutComponent } from './layouts/teacher-layout/teacher-layout.component';
import { StudentLayoutComponent } from './layouts/student-layout/student-layout.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { RoleGuard } from './shared/guards/role.guard';
import { RegisterLayoutComponent } from './layouts/register-layout/register-layout.component';
import { RefreshComponent } from './pages/refresh/refresh.component';
import { LevelingLayoutComponent } from './layouts/leveling-layout/leveling-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'site',
    pathMatch: 'full'
  }, {
    path: 'site',
    component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/site-layout/site-layout.module#SiteLayoutModule'
      }
    ],    
  }, {
    path: 'complete-register',
    children: [
      {
        path: '',
        loadChildren: './layouts/complete-register-layout/complete-register-layout.module#CompleteRegisterLayoutModule'
      }
    ],
  }, {
    path: 'register',
    component: RegisterLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/register-layout/register-layout.module#RegisterLayoutModule'
      }
    ],
  }, {
    path: 'leveling',
    component: LevelingLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/leveling-layout/leveling-layout.module#LevelingLayoutModule'
      }
    ],
  }, {
    path: 'student',
    component: StudentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/student-layout/student-layout.module#StudentLayoutModule'
      }
    ],   
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
    data: { role: ['ALUNO'] }
  }, {
    path: 'teacher',
    component: TeacherLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/teacher-layout/teacher-layout.module#TeacherLayoutModule'
      }
    ],   
    canLoad: [AuthGuard],
    canActivate: [RoleGuard],
    data: { role: ['professor', 'gestor'] }
  }, {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/auth-layout/auth-layout.module#AuthLayoutModule'
      }
    ]
  }, {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  }, {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  }, {
    path: 'refresh',
    component: RefreshComponent,
    data: {
      title: "Refresh"
    }
  }, {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
